// React
import { useMemo, useRef, useState } from 'react';

// Custom components

// Styled
// Types
import { SubmissionReportType } from 'pages/TemplateDashboard/Tabs/Submissions/context';

// Utils
import TaskChecklist from 'components/TaskChecklist';
import { useDispatch } from 'react-redux';
import { closeDialog, setDialog } from 'store/actions/dialogActions';
import DIALOGS from 'utils/dialogIds';
import xeniaApi from 'api/index';
import Footer from 'components/AllDialogs/FullscreenTemplateInProgress/Footer';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

interface EditActiveSubmissionLogPropTypes {
  activeSubmission: SubmissionReportType;
  template?: any;
  handleArchiveLogs?: (logs: any[]) => void;
  hideCorrectiveTask?: boolean;
  feedbackActions?: any;
  isReviewMode?: boolean;
  hideHeaderactions?: boolean;
  canReview?: boolean;
  forcedUpdate?: boolean;
  setForcedUpdate?: (data: boolean) => void;
  showReviewOptions?: boolean;
  canEdit?: boolean;
}
const EditActiveSubmissionLog = ({
  activeSubmission,
  feedbackActions,
  isReviewMode = false,
  canReview = false,
}: EditActiveSubmissionLogPropTypes) => {
  const formattedDataRef = useRef<any>(null);
  const checklistLogRef = useRef<any>(null);
  const [submitting, setSubmitting] = useState(false);
  const [checklistLog, setChecklistLog] = useState<any>(null);
  const finalChecklistLogIdRef = useRef<any>(activeSubmission?.id);
  const dispatch = useDispatch();
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();

  const currentSubmission = useMemo(() => activeSubmission, [activeSubmission]);
  const handleSubmit = async () => {
    if (currentSubmission?.status !== 'In Progress' && isReviewMode) {
      setSubmitting(true);
      await xeniaApi.editChecklistState({
        logId: finalChecklistLogIdRef.current,
        data: formattedDataRef.current,
      });
      setSubmitting(false);
      return;
    }
  };

  const handleConfirmCancel = async () => {
    if (formattedDataRef.current?.items?.length === 0) {
      return;
    }
    dispatch(
      setDialog({
        open: true,
        dialogId: DIALOGS.CONFIRM_EDIT_SUBMISSION,
        data: {
          checkList: checklistLog,
          disableSubmission: true,
          onDiscard: () => {
            dispatch(closeDialog(DIALOGS.SUBMISSION_REVIEW_MODE_DIALOG));
            navigateWithWorkspaceUrl('/dashboard');
          },
          onChecklistSubmitCb: async () => {
            setSubmitting(true);
            await xeniaApi.editChecklistState({
              logId: activeSubmission?.id,
              data: formattedDataRef.current,
            });
            dispatch(
              setDialog({
                open: false,
                dialogId: DIALOGS.CONFIRM_EDIT_SUBMISSION,
              }),
            );
            setSubmitting(false);
          },
        },
      }),
    );
  };

  return (
    <>
      <TaskChecklist
        hideBottomButtons
        logId={currentSubmission?.id ?? undefined}
        taskId={undefined}
        checklistId={currentSubmission?.ChecklistId}
        CustomFooter={<Footer />}
        customFooterProps={{
          handleCancel: handleConfirmCancel,
          loading: submitting,
          isEditing:
            currentSubmission?.status !== 'In Progress' && isReviewMode,
          currentSubmission,
        }}
        handleSubmit={handleSubmit}
        handleChangeLog={(log) => {
          setChecklistLog(log);
          checklistLogRef.current = log;
        }}
        isLogSubmitted={false}
        isEditing={currentSubmission?.status !== 'In Progress'}
        handleChangeFormattedData={(data) => {
          formattedDataRef.current = data;
        }}
        isActionsAllowed={true}
        feedbackActions={feedbackActions}
        isReviewMode={isReviewMode}
        canReview={canReview}
      />
    </>
  );
};

export default EditActiveSubmissionLog;
